exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2a43r{border-radius:0;padding:15px;border-top:0}._2a43r h5{font-family:Roboto\\, Medium;margin:0}._2a43r p{margin-bottom:0}._1CDtN,._2a43r p{font-family:Roboto}._1CDtN{border-color:#797979;color:#e4002b;padding:8px;margin-top:15px;margin-right:10px}._1CDtN:hover{color:#fff!important;background-color:#e4002b!important}._1r6fs{border-radius:100%;width:84px;border:1px solid #797979;background-color:#797979}.Dhr6J{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"card": "_2a43r",
	"button": "_1CDtN",
	"imgMedicos": "_1r6fs",
	"cardButton": "Dhr6J"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ListCards/ListCards.css
// module id = 1282
// module chunks = 0 1